'use client'
import React, { useState, useEffect } from 'react'
import { useTranslations } from 'next-intl'
import isClearTripDomain from '@/src/utils/generalUtils/isClearTripDomain'

import { BreadcrumbsComponent, BreadcrumbItem } from './Breadcrumbs'

interface BreadcrumbsWrapperProps {
    items: BreadcrumbItem[]
    locale: string
}

const BreadcrumbsWrapper: React.FC<BreadcrumbsWrapperProps> = ({ items, locale }) => {
    const t = useTranslations('common')
    const [homeHref, setHomeHref] = useState(`/${locale}`)

    useEffect(() => {
        const isCT = isClearTripDomain()
        setHomeHref(isCT ? '/' : `/${locale}`)
    }, [locale])
    
    return (
        <BreadcrumbsComponent 
            items={items}
            locale={locale}
            homeLabel={t('home')}
            homeHref={homeHref}
        />
    )
}

export { BreadcrumbsWrapper }
export default BreadcrumbsWrapper
export type { BreadcrumbItem }